import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.info');
import {
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';

type ThreatKey = 'jamming' | 'hijacking' | 'sniffing';
type ThreatTheme = 'rose' | 'amber' | 'violet';

interface ThreatDetail {
    key: ThreatKey;
    index: string;
    shortLabel: string;
    title: string;
    englishTitle: string;
    signal: string;
    slogan: string;
    overview: string;
    domains: string[];
    mechanism: string[];
    impacts: string[];
    countermeasures: string[];
    theme: ThreatTheme;
}

@Component({
    selector: 'wiz-page-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.info/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.threat-page {
  background-image: linear-gradient(rgba(69, 211, 154, 0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(69, 211, 154, 0.025) 1px, transparent 1px);
  background-size: 32px 32px;
}

.threat-grid {
  background: radial-gradient(circle at 50% 0%, rgba(69, 211, 154, 0.08), transparent 42%), linear-gradient(180deg, transparent 60%, rgba(4, 10, 9, 0.58));
}

.threat-card,
.drawer-panel {
  --accent: #72e5b6;
  --accent-rgb: 114, 229, 182;
}

[data-theme=rose] {
  --accent: #fb7185;
  --accent-rgb: 251, 113, 133;
}

[data-theme=amber] {
  --accent: #fbbf24;
  --accent-rgb: 251, 191, 36;
}

[data-theme=violet] {
  --accent: #67e8f9;
  --accent-rgb: 103, 232, 249;
}

.threat-card {
  border-color: rgba(var(--accent-rgb), 0.24);
  background: linear-gradient(145deg, rgba(var(--accent-rgb), 0.075), rgba(11, 21, 20, 0.8)), #101c1b;
  color: var(--accent);
}

.threat-card::after {
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  width: 2rem;
  height: 1px;
  content: "";
  background: rgba(var(--accent-rgb), 0.35);
  box-shadow: 0 -5px 0 rgba(var(--accent-rgb), 0.15);
  transition: width 300ms ease;
}

.threat-card:hover,
.threat-card.is-active {
  border-color: rgba(var(--accent-rgb), 0.68);
  background: linear-gradient(145deg, rgba(var(--accent-rgb), 0.14), rgba(11, 21, 20, 0.88)), #101c1b;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.22), 0 0 34px rgba(var(--accent-rgb), 0.1);
  transform: translateY(-2px);
}

.threat-card:hover::after,
.threat-card.is-active::after {
  width: 3.5rem;
}

.threat-card-glow {
  background: rgba(var(--accent-rgb), 0.26);
  opacity: 0.35;
}

.threat-card:hover .threat-card-glow,
.threat-card.is-active .threat-card-glow {
  opacity: 0.75;
}

.threat-marker {
  background: var(--accent);
  box-shadow: 0 0 12px rgba(var(--accent-rgb), 0.88);
}

.drawer-layer {
  visibility: hidden;
  pointer-events: none;
  transition: visibility 0s linear 320ms;
}

.drawer-layer.is-open {
  visibility: visible;
  pointer-events: auto;
  transition-delay: 0s;
}

.drawer-backdrop {
  opacity: 0;
  transition: opacity 300ms ease-out;
}

.drawer-panel {
  transform: translate3d(0, calc(100% + 24px), 0);
  transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;
}

.drawer-layer.is-open .drawer-backdrop {
  opacity: 1;
}

.drawer-layer.is-open .drawer-panel {
  transform: translate3d(0, 0, 0);
}

.drawer-accent {
  background: rgba(var(--accent-rgb), 0.22);
}

.theme-badge {
  border-color: rgba(var(--accent-rgb), 0.38);
  background: rgba(var(--accent-rgb), 0.1);
  color: var(--accent);
}

.theme-text {
  color: var(--accent);
}

.detail-card {
  transition: border-color 180ms ease, background-color 180ms ease;
}

.detail-card:hover {
  border-color: rgba(var(--accent-rgb), 0.2);
  background: rgba(var(--accent-rgb), 0.035);
}

.drawer-scroll {
  scrollbar-color: rgba(var(--accent-rgb), 0.42) rgba(255, 255, 255, 0.035);
  scrollbar-width: thin;
}

.drawer-scroll::-webkit-scrollbar {
  width: 6px;
}

.drawer-scroll::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.035);
}

.drawer-scroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(var(--accent-rgb), 0.42);
}

@media (min-width: 1024px) {
  .drawer-layer {
    left: 14rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .threat-card,
  .threat-card::after,
  .threat-card-glow,
  .drawer-backdrop,
  .drawer-panel {
    transition-duration: 1ms !important;
  }
  .threat-card:hover,
  .threat-card.is-active {
    transform: none;
  }
}`],
})
export class PageInfoComponent implements OnInit, OnDestroy {
    @ViewChild('closeButton') public closeButton?: ElementRef<HTMLButtonElement>;

    public selectedThreat: ThreatDetail | null = null;
    public isDrawerOpen = false;

    public readonly threats: ThreatDetail[] = [
        {
            key: 'jamming',
            index: '01',
            shortLabel: 'JAMMING',
            title: 'RF 스펙트럼 재밍',
            englishTitle: 'RF Spectrum Jamming',
            signal: 'RF LINK / DENIAL',
            slogan: '통신 대역을 소음으로 장악해 드론의 지휘·제어 링크를 끊습니다.',
            overview: '공격자가 조종·텔레메트리 주파수에 강한 간섭 신호를 주입해 정상 신호의 신호대잡음비를 무너뜨리는 가용성 공격입니다.',
            domains: ['가용성'],
            mechanism: [
                '표적 드론이 사용하는 제어·영상·GNSS 대역을 탐색합니다.',
                '동일 대역에 광대역 또는 지향성 고출력 신호를 송출합니다.',
                '수신기가 정상 패킷을 복조하지 못하면서 링크 품질과 위치 신뢰도가 급락합니다.',
            ],
            impacts: [
                '조종 명령과 텔레메트리의 지연·유실',
                '자동 복귀, 비상 착륙 또는 임무 중단',
                'GNSS 교란이 동반될 경우 항법 오차 확대',
            ],
            countermeasures: [
                '주파수 도약(FHSS)과 적응형 채널 전환',
                '지향성 안테나·출력 제어와 간섭원 방향 탐지',
                '링크 단절 시 안전 복귀 경로와 관성항법 이중화',
            ],
            theme: 'rose',
        },
        {
            key: 'hijacking',
            index: '02',
            shortLabel: 'HIJACKING',
            title: '하이재킹 & 스푸핑',
            englishTitle: 'Hijacking & Spoofing',
            signal: 'C2 LINK / TAKEOVER',
            slogan: '신뢰된 조종자와 위치 신호를 위조해 기체의 통제권을 탈취합니다.',
            overview: '취약한 인증·암호화 또는 위조된 항법 신호를 악용해 명령의 출처와 기체 위치를 속이는 무결성 중심 공격입니다.',
            domains: ['무결성', '가용성'],
            mechanism: [
                '무선 링크와 프로토콜의 인증·재전송 방어 취약점을 식별합니다.',
                '탈취한 세션 또는 위조 패킷으로 정상 조종 명령을 가장합니다.',
                'GPS 스푸핑은 점진적으로 거짓 좌표·시간을 주입해 경로 판단을 왜곡합니다.',
            ],
            impacts: [
                '비인가 조종 명령 실행과 임무 경로 변경',
                '위치·고도·시간 정보의 신뢰성 상실',
                '기체 탈취, 제한구역 침범 또는 충돌 위험',
            ],
            countermeasures: [
                '상호 인증, 명령 서명, 세션 키 순환과 재전송 방지',
                'GNSS·관성항법·비전 위치의 교차 검증',
                '비정상 명령 빈도·경로 편차 탐지와 권한 즉시 폐기',
            ],
            theme: 'amber',
        },
        {
            key: 'sniffing',
            index: '03',
            shortLabel: 'SNIFFING',
            title: '패킷 스니핑 & 도청',
            englishTitle: 'Packet Sniffing & Eavesdropping',
            signal: 'DATA LINK / INTERCEPT',
            slogan: '공중의 무선 패킷을 은밀히 수집해 영상·좌표·운용 정보를 노출합니다.',
            overview: '암호화되지 않았거나 키 관리가 약한 무선 트래픽을 수동 수집·분석해 임무 데이터와 통신 패턴을 획득하는 기밀성 공격입니다.',
            domains: ['기밀성'],
            mechanism: [
                '표적 채널을 수동 모니터링하며 프레임과 메타데이터를 캡처합니다.',
                '프로토콜 구조, 송수신 주기, 식별자와 암호화 적용 여부를 분석합니다.',
                '평문 또는 취약한 키로 보호된 페이로드에서 영상·좌표·명령 정보를 복원합니다.',
            ],
            impacts: [
                '실시간 영상, 위치, 비행 경로와 임무 정보 노출',
                '기체·조종자 식별 및 운용 패턴 프로파일링',
                '수집 정보가 후속 스푸핑·하이재킹에 활용될 위험',
            ],
            countermeasures: [
                '전 구간 강력한 암호화와 장치별 고유 키 적용',
                '키 수명 단축, 안전한 교환·폐기와 인증서 관리',
                '불필요한 브로드캐스트 최소화 및 비정상 수신자 탐지',
            ],
            theme: 'violet',
        },
    ];

    private readonly closeDuration = 320;
    private closeTimer: ReturnType<typeof setTimeout> | null = null;
    private lastTrigger: HTMLButtonElement | null = null;
    private previousBodyOverflow = '';

    public async ngOnInit() {
    }

    public ngOnDestroy() {
        this.clearCloseTimer();
        this.restoreBodyScroll();
    }

    public trackByKey(_index: number, threat: ThreatDetail) {
        return threat.key;
    }

    public isActive(threat: ThreatDetail) {
        return this.isDrawerOpen && this.selectedThreat?.key === threat.key;
    }

    public openThreat(threat: ThreatDetail, event: MouseEvent) {
        this.clearCloseTimer();
        this.lastTrigger = event.currentTarget as HTMLButtonElement;

        if (!this.selectedThreat) {
            this.previousBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }

        this.selectedThreat = threat;

        window.requestAnimationFrame(() => {
            this.isDrawerOpen = true;
            window.requestAnimationFrame(() => {
                this.closeButton?.nativeElement.focus();
            });
        });
    }

    public closeDrawer() {
        if (!this.selectedThreat) return;

        this.clearCloseTimer();
        this.isDrawerOpen = false;

        this.closeTimer = setTimeout(() => {
            this.selectedThreat = null;
            this.closeTimer = null;
            this.restoreBodyScroll();
            this.lastTrigger?.focus();
        }, this.closeDuration);
    }

    @HostListener('document:keydown.escape', ['$event'])
    public handleEscape(event: KeyboardEvent) {
        if (!this.isDrawerOpen) return;

        event.preventDefault();
        this.closeDrawer();
    }

    private clearCloseTimer() {
        if (this.closeTimer !== null) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    }

    private restoreBodyScroll() {
        document.body.style.overflow = this.previousBodyOverflow;
    }
}

export default PageInfoComponent;